export const SET_LOCALE = 'SET_LOCALE'
export const SET_LANG = 'SET_LANG' // todo use set locale in dsite instead of this
